import { CapoPlugin } from "/home/forge/develop.oase-bw.de/releases/20250417144722/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];